import Vue from 'vue';
import Component from 'vue-class-component';
import REQ_URL from '@/consts/req-url';
import { MapDataAddress, MapData } from '@/types/map-data';
//import { gmapApi } from 'vue2-google-maps'
import ContactTable from '@/components/ContactTable/ContactTable'
import normalizeAddress from '@/api/normalizeAddress';
import { Watch } from 'vue-property-decorator';

@Component({
    components: {
        ContactTable
    }
})
export default class Contacts extends Vue {
    loading = true
    mapDataArr: MapData[] = []
    infoWindow = false
    selectedMarker = null
    openedEP = null
    @Watch('openedEP') onChangeOpenedEP(val: number | null) {
        if (val !== null && !this.selectedMarker) {
            console.log(val)
            setTimeout(() =>  this.setBoundCenter(), 300)
           
        }
    }
    async getMapData() {
        try {
            let data = await this.$fetch<MapData[]>(REQ_URL.GET_CONTACTS_MAP)
            if (data.body) this.mapDataArr = data.body
        } catch (error) {
            return false
        }
        return true
    }
    get markers() {
        let arr: any = []
        this.mapDataArr.forEach(element => {
            arr.push(this.tranformMapDataToMarker(element))
        });
        return arr
    }
    get google() {
        return (window as any).google
    }
    tranformMapDataToMarker(element: MapData): any {
        return {
            position: {
                lat: element['Адрес']['Координаты'].lat,
                lng: element['Адрес']['Координаты'].lng
            },
            title: element['Адрес']['Город'],
            icon: require('../../assets/spotlight-poi.png'),
            infoOpts: {
                content: normalizeAddress(element.Адрес),
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            },
            regions: element["Основные данные"].Регионы
        }
    }
    async selectMarker(mpData: MapData) {
        this.selectedMarker = this.tranformMapDataToMarker(mpData)
        this.infoWindow = true
        let map: any = await (this.$refs.map as any).$mapPromise;
        map.setCenter({
            lat: mpData['Адрес']['Координаты'].lat,
            lng: mpData['Адрес']['Координаты'].lng
        })
        map.setZoom(15)
    }
    async setBoundCenter() {
        let map: any = await (this.$refs.map as any).$mapPromise;
        var bounds = new this.google.maps.LatLngBounds();
        this.markers.forEach((element: any) => {
            var latlng = new this.google.maps.LatLng(element.position.lat, element.position.lng);
            bounds.extend(latlng);
        });
        map.fitBounds(bounds);
    }
    async mounted() {
        await this.getMapData()
        this.setBoundCenter()
    }
}